import { AlertProps, Alert as MuiAlert } from "@mui/material";

type Props = AlertProps;

export const Alert = ({ children, ...props }: Props) => {
  return <MuiAlert {...props}>{children}</MuiAlert>;
};
